<template>
  <div class="container">
    <div
      class="item"
      v-for="(item, index) of blockArr"
      :key="index"
      :style="'background: ' + item.color"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    level: {
      type: String,
      default: ''
    }
  },
  computed: {
    blockArr () {
      let res = []
      const COLOR = {
        danger: '#F56C6C',
        warn: '#E6A23C',
        success: '#67C23A'
      }
      switch (this.level) {
        case '低':
          res = [
            {
              color: COLOR['danger']
            }
          ]
          return res
        case '中':
          res = [
            {
              color: COLOR['warn']
            },
            {
              color: COLOR['warn']
            }
          ]
          return res
        case '高':
          res = [
            {
              color: COLOR['success']
            },
            {
              color: COLOR['success']
            },
            {
              color: COLOR['success']
            }
          ]
          return res
        default:
          return res
      }
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  // padding: 1px 2px 2px 0;
  width: 81px;
  height: 20px;
  border: 1px solid #666666;
  border-radius: 8px;
  display: flex;
  overflow: hidden;
  .item {
    width: 27px;
    height: 20px;
  }
}
</style>
